import React, { useContext, useEffect, useState } from "react";
import { controller, endpoints } from "../../../api/actions/api";
import * as actions from "../../../api/actions/actions";
import { connect } from "react-redux";
import { AppContext } from "../../../App";
import RepNav from "./RepNav";
import { Table } from "../../../layout";
import moment from "moment";

const tblHeader = () => (
  <div className="d-flex a-center flex-wrap">
    <h2 className="border-left h fw-4 fs-16 gray-color tx-upp">
      Ownership Status
    </h2>
  </div>
);

const OwnershipStatus = (props) => {
  const { _getById, _hoa } = props;
  const { setLoader } = useContext(AppContext);
  const [csvHeader, setCsvHeader] = useState([]);
  const [tblData, setTblData] = useState([]);
  const [ownerships, setOwnerships] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [sortDate, setSortDate] = useState({
    fromDate: `1/1/${new Date().getFullYear()}`,
    toDate: `12/31/${new Date().getFullYear()}`,
  });

  useEffect(() => {
    setCsvHeader([
      { label: "Unit", key: "unitName" },
      { label: "Owner", key: "ownerName" },
      { label: "Status", key: "status" },
      { label: "Start Date", key: "startDate" },
      { label: "End Date", key: "endDate" },
    ]);
    return () => {
      setCsvHeader([]);
    };
  }, []);

  useEffect(() => {
    setTblData([
      ...filteredData.map((j) => {
        return {
          ...j,
          status: j.status === 1 ? "Active" : "End",
          unitName: j.unit && j.unit.title,
          ownerName: j.owner && j.owner.fullName,
        };
      }),
    ]);
    return () => {
      setTblData([]);
    };
  }, [filteredData]);

  useEffect(() => {
    if (_hoa.id) {
      setLoader(true);
      _getById(
        endpoints.Owner + controller.GetOwnershipsByHoa,
        _hoa.id,
        null,
        (res) => {
          setLoader(false);
          res.status === 200 && setOwnerships(res.result);
        }
      );
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_hoa]);

  useEffect(() => {
    ownerships &&
      setFilteredData([
        ...ownerships.filter(
          (j) =>
            moment(j.startDate, "MM/DD/YYYY") >=
              moment(sortDate.fromDate, "MM/DD/YYYY") &&
            moment(j.startDate, "MM/DD/YYYY") <=
              moment(sortDate.toDate, "MM/DD/YYYY")
        ),
      ]);

    return () => {
      setFilteredData([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ownerships, sortDate]);

  return (
    <>
      <div className="mt-20 mb-10">
        <RepNav
          {...{
            csvHeader,
            csvData: tblData,
            sortDate,
            setSortDate,
            title: "OWNERSHIP STATUS",
            showTitle: false,
          }}
        />
      </div>
      <div>
        <Table
          shadow={false}
          ActionComp={() => <></>}
          HeaderComp={tblHeader}
          tblHead={[
            { id: "unitName", label: "Unit" },
            { id: "ownerName", label: "Owner" },
            { id: "status", label: "Status" },
            { id: "startDate", label: "Start Date" },
            { id: "endDate", label: "End Date" },
          ]}
          tblData={tblData}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  _hoa: state.storeData.defHoa,
});

const mapActionToProps = {
  _getById: actions.getById,
  _delete: actions.Delete,
};

export default connect(mapStateToProps, mapActionToProps)(OwnershipStatus);
